<template>
  <div class="main kanri-page" id="admin-info-edit">
    <h2 class="page-title"><strong>お知らせ登録【管理】</strong></h2>

    <!-- <section class="main-section error-message">
      <i class="ico-error"></i>
      <p>エラーメッセージが入りますエラーメッセージが入ります。</p>
      <p>
        エラーメッセージが入りますエラーメッセージが入りますエラーメッセージが入ります。
      </p>
    </section> -->
    <el-col :span="24">
      <section class="main-section gray-top-border">
        <h3 class="section-title">お知らせ対象</h3>

        <!-- <el-col :span="24"> -->
        <el-form ref="form" :model="information" label-width="200px">
          <el-form-item label="対象">
            <el-select v-model="information.target" placeholder="Select">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="個別お知らせ対象部屋番号"
            v-show="information.target == 'Personal'"
          >
            <el-input
              type="textarea"
              :rows="4"
              placeholder="個別お知らせを選択した場合の表示対象部屋番号（例：301,302,507）※カンマ区切り"
              v-model="information.target_user"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <!-- </el-col> -->
      </section>
      <!--/.main-section-->

      <section class="main-section gray-top-border">
        <h3 class="section-title">基本情報</h3>

        <!-- <el-col :span="24"> -->
        <el-form ref="form" :model="information" label-width="200px">
          <el-form-item label="タイトル">
            <el-input
              type="text"
              placeholder="タイトル"
              v-model="information.title"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="本文">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="本文"
              v-model="information.body"
            >
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="囲み部分">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="例）2020年10月10日（土）13:15〜15:00 第1期通常総会 場所：マンション内コミュニティルーム"
              v-model="information.kakomi"
            >
            </el-input>
          </el-form-item> -->
          <el-form-item label="表示登録日">
            <el-col :span="11">
              <el-date-picker
                v-model="information.registration_at"
                type="date"
                placeholder="表示登録日"
                style="width: 100%;"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="掲載期間">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="掲載開始"
                v-model="information.display_range.start"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="1">〜</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="掲載終了"
                v-model="information.display_range.end"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="リンク">
            <el-input type="text" placeholder="URL" v-model="information.url">
            </el-input>
          </el-form-item>
          <el-form-item label="リンクターゲット">
            <el-switch
              v-model="information.url_target"
              active-text="別ウインドウ"
              inactive-text="同じウインドウ"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="ラベル">
            <el-select v-model="information.label" placeholder="Select">
              <el-option
                v-for="item in labels"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="トップページに表示">
            <el-switch
              v-model="information.is_top"
              active-text="表示"
              inactive-text="非表示"
            >
            </el-switch>
          </el-form-item>
        </el-form>
        <!-- </el-col> -->
      </section>
      <!--/.main-section-->

      <section class="main-section gray-top-border">
        <h3 class="section-title">スケジュール</h3>

        <!-- <el-col :span="24"> -->
        <el-form ref="form" :model="information" label-width="200px">
          <el-form-item label="スケジュール機能">
            <el-switch
              v-model="information.is_schedule"
              active-text="あり"
              inactive-text="なし"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="カレンダー表示テキスト">
            <el-input
              type="text"
              placeholder="カレンダー表示テキスト"
              v-model="information.calender_text"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="スケジュール期間">
            <el-col :span="11">
              <el-date-picker
                type="datetime"
                placeholder="掲載開始"
                v-model="information.calender_range.start"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="1">～</el-col>
            <el-col :span="11">
              <el-date-picker
                type="datetime"
                placeholder="掲載終了"
                v-model="information.calender_range.end"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
          </el-form-item>
        </el-form>
        <!-- </el-col> -->
      </section>
      <!--/.main-section-->

      <section class="main-section gray-top-border">
        <h3 class="section-title">通知</h3>

        <!-- <el-col :span="24"> -->
        <el-form ref="form" :model="information" label-width="200px">
          <el-form-item label="対象にメール">
            <el-switch
              v-model="information.notification_mail"
              active-text="する"
              inactive-text="しない"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="対象にPUSH通知">
            <el-switch
              v-model="information.notification_push"
              active-text="する"
              inactive-text="しない"
            >
            </el-switch>
          </el-form-item>
        </el-form>
        <!-- </el-col> -->
      </section>
      <!--/.main-section-->
    </el-col>
    <section class="main-section gray-top-border buttons">
      <p class="section-block center">
        <button
          class="bt bt-gray"
          @click="$router.push({ name: 'admin_information' })"
        >
          戻る
        </button>
      </p>
      <p class="section-block center">
        <button class="bt bt-green" @click="onUpdate">保存</button>
      </p>
    </section>
    <!--/.main-section-->
  </div>
  <!--/.main-->
</template>

<script>
import InfoService from "../../../services/info.service";
// eslint-disable-next-line
import UserService from "../../../services/user.service";
import store from "../../../store";
// eslint-disable-next-line
import moment from "moment";

export default {
  name: "admin-info-edit",
  data: function() {
    return {
      taishou: "",
      options: [
        {
          value: "",
          label: "選択してください",
        },
        {
          value: "All",
          label: "全員にお知らせ",
        },
        {
          value: "OwnedResident",
          label: "区分所有者",
        },
        {
          value: "RentResident",
          label: "賃借人",
        },
        {
          value: "Director",
          label: "理事会メンバー",
        },
        {
          value: "Personal",
          label: "個別お知らせ",
        },
      ],
      labels: [
        {
          value: "tag01",
          label: "作業予定",
        },
        {
          value: "tag02",
          label: "重要",
        },
        {
          value: "tag03",
          label: "書類",
        },
        {
          value: "tag04",
          label: "理事会",
        },
      ],
      information: {
        target: "",
        target_user: "",
        title: "",
        body: "",
        kakomi: "",
        registration_at: "",
        display_range: { start: "", end: "" },
        url: "",
        url_target: false,
        label: "",
        is_top: true,
        is_schedule: false,
        calender_text: "",
        calender_range: { start: "", end: "" },
        notification_mail: false,
        notification_push: false,
      },
    };
  },
  async mounted() {
    if (this.$route.params.id == "new") {
      return;
    }

    try {
      const response = await InfoService.findOne(this.$route.params.id);
      console.log("++mounted");
      console.log(response);
      // console.log(response.data.docs.length);
      if (response.data.length > 0) {
        await this.$nextTick();
        this.information = response.data[0];
      } else {
        this.information = [];
      }
    } catch (error) {
      console.log(error);
      this.$router.push({ name: "notfound404" });
    }
  },
  beforeRouteEnter(to, from, next) {
    const currentUser = store.state.auth.user;
    console.log(currentUser);
    if (currentUser && !currentUser.permissions.includes("Chairman")) {
      console.log(":401");
      next({ name: "notfound404" });
    } else {
      next();
    }
  },
  methods: {
    async onUpdate() {
      console.log(this.information);
      const result = await InfoService.update(this.information);
      console.log("-----");
      console.log(result);
      console.log(process.env);

      if (this.information.notification_push) {
        const title = this.information.title;
        const body = this.information.body;
        // const title = `${process.env.VUE_APP_MESSAGING_TITLE}:おしらせ`;
        // let body = `${this.information.calender_text}:${moment(
        //   this.information.calender_range.start,
        // ).format("YYYY/MM/DD HH:mm")}〜${moment(
        //   this.information.calender_range.end,
        // ).format("YYYY/MM/DD HH:mm")}`;
        const clickAction = `${process.env.VUE_APP_BASE_URL}/information/${this.information._id}`;
        console.log(clickAction);
        // return;
        // eslint-disable-next-line
        const doc = await UserService.messaging(
          title,
          body,
          result.data.tokens,
          clickAction,
        );
      }
      if (this.information.notification_mail) {
        const subject = `${this.currentUser.apartmentName}からのお知らせ`;
        let body = `${this.currentUser.apartmentName}\n`;
        body += `<<roomNo>>号室\n`;
        body += `ご利用者様\n\n${moment().format(
          "YYYY年MM月DD日",
        )}にお知らせが更新されました。\n詳細は下記URLからご確認下さい。\n\nタイトル：${
          this.information.title
        }\n\nURL: ${process.env.VUE_APP_BASE_URL}/information/${
          this.information._id
        }\n\n※このメールアドレスは配信専用です。このメッセージにはご返信いただけません。`;
        console.log(subject);
        console.log(body);
        // eslint-disable-next-line
        const doc = await UserService.sendmail(
          subject,
          body,
          result.data.emails,
        );
        console.log(doc);
      }
      this.$router.push({ name: "admin_information" });
    },
  },
};
</script>

<style></style>
